import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

const RootLayout = () => {
   return (
      <div className="profile-page">
         <div className="wrapper" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
            <Header />
            <Outlet />
            <Footer />
         </div>
      </div>
   );
};

export default RootLayout;